export class UnknowErrorException extends Error {
  constructor({ message = 'Error desconocido', errorCode = '99' }) {
    super(message);
    this.name = this.constructor.name;
    this.errorCode = errorCode;
    Error.captureStackTrace(this, this.constructor);
  }
}
